import fetch from "isomorphic-fetch";
import {
    API2_URL,
    REPORTS_FINANCIAL_REQUEST,
    REPORTS_FINANCIAL,
    REPORTS_FINANCIAL_CLEAR,
    REPORTS_FINANCIAL_FAIL,
    REPORTS_FINANCIAL_EDIT_REQUEST,
    REPORTS_FINANCIAL_GOAL,
    REPORTS_FINANCIAL_ACTIVITY,
    REPORTS_FINANCIAL_EDIT_FAIL,
    /*REPORTS_FINANCIAL_EDIT_INVOICE_FAIL, */
    REPORTS_EXPENSES,
    REPORTS_EXPENSES_REQUEST,
    REPORTS_EXPENSES_CLEAR,
    REPORTS_EXPENSES_FAIL,
    REPORTS_EXPENSES_EDIT,
    REPORTS_EXPENSES_EDIT_REQUEST,
    REPORTS_EXPENSES_EDIT_FAIL,
    REPORTS_EMPLOYEES,
    REPORTS_EMPLOYEES_EDIT,
    REPORTS_EMPLOYEES_EDIT_REQUEST,
    REPORTS_EMPLOYEES_EDIT_FAIL,
    REPORTS_EMPLOYEES_REQUEST,
    REPORTS_EMPLOYEES_CLEAR,
    REPORTS_EMPLOYEES_FAIL,
    REPORTS_SUMMARY,
    REPORTS_SUMMARY_REQUEST,
    REPORTS_SUMMARY_CLEAR,
    REPORTS_SUMMARY_FAIL,
    REPORTS_SUMMARY_COMPLETE,
    REPORTS_SURVEYS,
    REPORTS_SURVEYS_REQUEST,
    REPORTS_SURVEYS_CLEAR,
    REPORTS_SURVEYS_FAIL /*, REPORTS_SURVEYS_COMPLETE*/
} from "../store/config";
import _ from "lodash";
import { newNotification } from "./notifications";
import { sessionService } from 'redux-react-session';
import FileSaver from 'file-saver';

export const reportsFinancial = (modality, state, mun = undefined) => (dispatch) => {
    return dispatch(sessionService.loadUser)
        .then(sess => {
            dispatch(reportsFinancialRequest());
            dispatch(reportsFinancialClear());

            const options = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sess.profile.access_token}`
                },
                method: 'get'
            };

            return fetch(`${API2_URL}/projects/reports/financial/${modality}/${state}${mun !== undefined ? '/' + mun : ''}`, options)
                .then(result => {
                    console.log(result);
                    if (result.status >= 200 && result.status < 300) {
                        return result.json();
                    } else {
                        return result.json().then(Promise.reject.bind(Promise));
                    }
                })
                .then(
                    json => dispatch(reportsFinancialData(json)),
                    error => {
                        dispatch(newNotification({ title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error), type: "danger" }));
                        return dispatch(reportsFinancialFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
                    }
                );
        })
}

export const financialGoalStatusSave = (values, data, modality, state, mun = undefined) => {
    return dispatch => {
        return dispatch(sessionService.loadUser)
            .then(sess => {
                dispatch(reportsFinancialEditRequest());

                const options = {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${sess.profile.access_token}`
                    },
                    method: 'post',
                    body: JSON.stringify(values)
                };

                return fetch(`${API2_URL}/projects/reports/financial/goal/${values.project_goal_id}/status/${modality}/${state}${mun !== undefined ? '/' + mun : ''}`, options)
                    .then(result => {
                        if (result.status >= 200 && result.status < 300) {
                            return result.json();
                        } else {
                            return result.json().then(Promise.reject.bind(Promise));
                        }
                    })
                    .then(
                        json => {
                            dispatch(newNotification({ title: "¡Éxito!", content: json.message ? json.message : 'El estatus de la meta se guardó correctamente', type: "success" }));
                            return dispatch(financialGoalData(json, values, data, modality, 'close'));
                        },
                        error => {
                            dispatch(newNotification({ title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error), type: "danger" }));
                            return dispatch(reportsFinancialEditFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
                        }
                    );
            })
    }
};

export const financialGoalDocumentSave = (values, data, modality, state, mun = undefined) => {
    return dispatch => {
        return dispatch(sessionService.loadUser)
            .then(sess => {
                dispatch(reportsFinancialEditRequest());

                let body = new FormData();

                _.mapKeys(values.documents, (o, j) => {
                    if (o !== undefined) {
                        if (!_.isObject(o) && !_.startsWith(o, 'http://')) {
                            body.append(`documents[${j}]`, o);
                        } else if (_.isObject(o) && !_.isEmpty(o) && o[0] !== undefined) {
                            body.append(`documents[${j}]`, o[0]);
                        }
                    }
                });

                if (modality === 'modalidad-iii') {
                    if (values.agency_id !== undefined) {
                        body.append(`agency_id`, values.agency_id);
                    }
                }

                if (values.comply_rules !== undefined) {
                    body.append(`comply_rules`, values.comply_rules);
                }

                if (values.comply_topics !== undefined) {
                    body.append(`comply_topics`, values.comply_topics);
                }

                const options = {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${sess.profile.access_token}`
                    },
                    method: 'post',
                    body: body
                };

                return fetch(`${API2_URL}/projects/reports/financial/goal/${values.project_goal_id}/documents/${modality}/${state}${mun !== undefined ? '/' + mun : ''}`, options)
                    .then(result => {
                        if (result.status >= 200 && result.status < 300) {
                            return result.json();
                        } else {
                            return result.json().then(Promise.reject.bind(Promise));
                        }
                    })
                    .then(
                        json => {
                            dispatch(newNotification({ title: "¡Éxito!", content: json.message ? json.message : 'Archivos guardados correctamente', type: "success" }));
                            return dispatch(financialGoalData(json, values, data, modality, 'close'));
                        },
                        error => {
                            dispatch(newNotification({ title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error), type: "danger" }));
                            return dispatch(reportsFinancialEditFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
                        }
                    );
            })
    }
};

export const financialGoalDocumentDelete = (values, data, id, modality, state, mun = undefined) => {
    return dispatch => {
        return dispatch(sessionService.loadUser)
            .then(sess => {
                dispatch(reportsFinancialEditRequest());

                const options = {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${sess.profile.access_token}`
                    },
                    method: 'delete'
                };

                return fetch(`${API2_URL}/projects/reports/financial/goal/${values.project_goal_id}/documents/${id}/${modality}/${state}${mun !== undefined ? '/' + mun : ''}`, options)
                    .then(result => {
                        if (result.status >= 200 && result.status < 300) {
                            return result.json();
                        } else {
                            return result.json().then(Promise.reject.bind(Promise));
                        }
                    })
                    .then(
                        json => {
                            dispatch(newNotification({ title: "¡Éxito!", content: json.message ? json.message : 'Archivo eliminado correctamente', type: "success" }));
                            return dispatch(financialGoalData(json, values, data, modality, 'delete'));
                        },
                        error => {
                            dispatch(newNotification({ title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error), type: "danger" }));
                            return dispatch(reportsFinancialEditFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
                        }
                    );
            })
    }
};

export const financialGoalInvoicesSave = (values, data, modality, state, mun = undefined) => {
    return dispatch => {
        return dispatch(sessionService.loadUser)
            .then(sess => {
                dispatch(reportsFinancialEditRequest());

                let body = new FormData();
                let countCdm = 0;

                _.mapKeys({ pdf: values.pdf, xml: values.xml, sat: values.sat }, (o, j) => {
                    if (o !== undefined) {
                        if (!_.isObject(o) && !_.startsWith(o, 'http://')) {
                            body.append(j, o);
                        } else if (_.isObject(o) && !_.isEmpty(o) && o[0] !== undefined) {
                            body.append(j, o[0]);
                        }
                    }
                });

                if (modality === 'modalidad-iii') {
                    _.mapKeys(values.agencies, (o) => {
                        let agencyId = undefined;
                        _.mapKeys(o, (v, k) => {
                            if (k === 'id') {
                                agencyId = v;
                            }

                            if (k === 'amount') {
                                if (v !== undefined && !_.isEmpty(v)) {
                                    body.append(`agencies[${countCdm}][agency_id]`, agencyId);
                                    body.append(`agencies[${countCdm}][${k}]`, v);
                                    countCdm += 1;
                                }
                            }
                        })
                    });
                }

                const options = {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${sess.profile.access_token}`
                    },
                    method: 'post',
                    body: body
                };

                return fetch(`${API2_URL}/projects/reports/financial/goal/${values.project_goal_id}/invoices/${modality}/${state}${mun !== undefined ? '/' + mun : ''}`, options)
                    .then(result => {
                        if (result.status >= 200 && result.status < 300) {
                            return result.json();
                        } else {
                            //dispatch(reportsFinancialEditInvoiceFail());
                            return result.json().then(Promise.reject.bind(Promise));
                        }
                    })
                    .then(
                        json => {
                            dispatch(newNotification({ title: "¡Éxito!", content: json.message, type: "success" }));
                            return dispatch(financialGoalInvoiceData(json, values, data, modality, 'close'));
                        },
                        error => {
                            dispatch(newNotification({ title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error), type: "danger" }));
                            return dispatch(reportsFinancialEditFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
                        }
                    );
            })
    }
};

export const financialGoalInvoiceDelete = (values, data, id, modality, state, mun = undefined) => {
    return dispatch => {
        return dispatch(sessionService.loadUser)
            .then(sess => {
                dispatch(reportsFinancialEditRequest());

                const options = {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${sess.profile.access_token}`
                    },
                    method: 'delete'
                };

                return fetch(`${API2_URL}/projects/reports/financial/goal/${values.project_goal_id}/invoices/${id}/${modality}/${state}${mun !== undefined ? '/' + mun : ''}`, options)
                    .then(result => {
                        if (result.status >= 200 && result.status < 300) {
                            return result.json();
                        } else {
                            return result.json().then(Promise.reject.bind(Promise));
                        }
                    })
                    .then(
                        json => {
                            dispatch(newNotification({ title: "¡Éxito!", content: json.message ? json.message : 'La factura se elimino correctamente', type: "success" }));
                            return dispatch(financialGoalInvoiceData(json, values, data, modality, 'delete'));
                        },
                        error => {
                            dispatch(newNotification({ title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error), type: "danger" }));
                            return dispatch(reportsFinancialEditFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
                        }
                    );
            })
    }
};

export const financialActivityStatusSave = (values, data, modality, state, mun = undefined) => {
    return dispatch => {
        return dispatch(sessionService.loadUser)
            .then(sess => {
                dispatch(reportsFinancialEditRequest());

                const options = {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${sess.profile.access_token}`
                    },
                    method: 'post',
                    body: JSON.stringify(values)
                };

                return fetch(`${API2_URL}/projects/reports/financial/goal/${values.project_goal_id}/activity/${values.pga_id}/status/${modality}/${state}${mun !== undefined ? '/' + mun : ''}`, options)
                    .then(result => {
                        if (result.status >= 200 && result.status < 300) {
                            return result.json();
                        } else {
                            return result.json().then(Promise.reject.bind(Promise));
                        }
                    })
                    .then(
                        json => {
                            dispatch(newNotification({ title: "¡Éxito!", content: json.message ? json.message : 'El estatus de la actividad se guardó correctamente', type: "success" }));
                            return dispatch(financialActivityData(json, values, data, modality, 'close'));
                        },
                        error => {
                            dispatch(newNotification({ title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error), type: "danger" }));
                            return dispatch(reportsFinancialEditFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
                        }
                    );
            })
    }
};

export const financialActivityMediaSave = (values, data, modality, state, mun = undefined) => {
    return dispatch => {
        return dispatch(sessionService.loadUser)
            .then(sess => {
                dispatch(reportsFinancialEditRequest());

                let body = new FormData();

                _.mapKeys(values.documents, (o, j) => {
                    if (o !== undefined) {
                        if (!_.isObject(o) && !_.startsWith(o, 'http://')) {
                            body.append(`documents[${j}]`, o);
                        } else if (_.isObject(o) && !_.isEmpty(o) && o[0] !== undefined) {
                            body.append(`documents[${j}]`, o[0]);
                        }
                    }
                });

                if (modality === 'modalidad-iii') {
                    if (values.agency_id !== undefined) {
                        body.append(`agency_id`, values.agency_id);
                    }
                }

                const options = {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${sess.profile.access_token}`
                    },
                    method: 'post',
                    body: body
                };

                return fetch(`${API2_URL}/projects/reports/financial/goal/${values.project_goal_id}/activity/${values.pga_id}/documents/${modality}/${state}${mun !== undefined ? '/' + mun : ''}`, options)
                    .then(result => {
                        if (result.status >= 200 && result.status < 300) {
                            return result.json();
                        } else {
                            return result.json().then(Promise.reject.bind(Promise));
                        }
                    })
                    .then(
                        json => {
                            dispatch(newNotification({ title: "¡Éxito!", content: json.message ? json.message : 'Archivos de verificacion correctamente guardados', type: "success" }));
                            return dispatch(financialActivityData(json, values, data, modality, 'close'));
                        },
                        error => {
                            dispatch(newNotification({ title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error), type: "danger" }));
                            return dispatch(reportsFinancialEditFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
                        }
                    );
            })
    }
};

export const financialActivityMediaDelete = (values, data, id, modality, state, mun = undefined) => {
    return dispatch => {
        return dispatch(sessionService.loadUser)
            .then(sess => {
                dispatch(reportsFinancialEditRequest());

                const options = {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${sess.profile.access_token}`
                    },
                    method: 'delete'
                };

                return fetch(`${API2_URL}/projects/reports/financial/goal/${values.project_goal_id}/activity/${values.pga_id}/documents/${id}/${modality}/${state}${mun !== undefined ? '/' + mun : ''}`, options)
                    .then(result => {
                        if (result.status >= 200 && result.status < 300) {
                            return result.json();
                        } else {
                            return result.json().then(Promise.reject.bind(Promise));
                        }
                    })
                    .then(
                        json => {
                            dispatch(newNotification({ title: "¡Éxito!", content: json.message ? json.message : 'El archivo se elimino correctamente', type: "success" }));
                            return dispatch(financialActivityData(json, values, data, modality, 'delete'));
                        },
                        error => {
                            dispatch(newNotification({ title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error), type: "danger" }));
                            return dispatch(reportsFinancialEditFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
                        }
                    );
            })
    }
};

export const financialGoalActorsSave = (values, data, modality, state, mun = undefined) => {
    let actors = [];

    _.map(values.actors, (item) => {
        return actors.push({ id: item.id })
    })

    return dispatch => {
        return dispatch(sessionService.loadUser)
            .then(sess => {
                dispatch(reportsFinancialEditRequest());

                const options = {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${sess.profile.access_token}`
                    },
                    method: 'post',
                    body: JSON.stringify({ actors })
                };

                return fetch(`${API2_URL}/projects/reports/financial/goal/${values.project_goal_id}/actors/${modality}/${state}${mun !== undefined ? '/' + mun : ''}`, options)
                    .then(result => {
                        if (result.status >= 200 && result.status < 300) {
                            return result.json();
                        } else {
                            return result.json().then(Promise.reject.bind(Promise));
                        }
                    })
                    .then(
                        json => {
                            dispatch(newNotification({ title: "¡Éxito!", content: json.message ? json.message : 'Actores guardados correctamente', type: "success" }));
                            return dispatch(financialGoalActorsData(json, values, data, modality, 'close'));
                        },
                        error => {
                            dispatch(newNotification({ title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error), type: "danger" }));
                            return dispatch(reportsFinancialEditFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
                        }
                    );
            })
    }
};

export const financialGoalConagoSave = (values, data, modality, state, mun = undefined) => {
    let conago_clauses = [];

    _.map(values.conago_clauses, (item) => {
        return conago_clauses.push({ id: item.id })
    })

    return dispatch => {
        return dispatch(sessionService.loadUser)
            .then(sess => {
                dispatch(reportsFinancialEditRequest());

                const options = {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${sess.profile.access_token}`
                    },
                    method: 'post',
                    body: JSON.stringify({ conago_clauses })
                };

                return fetch(`${API2_URL}/projects/reports/financial/goal/${values.project_goal_id}/conago-clauses/${modality}/${state}${mun !== undefined ? '/' + mun : ''}`, options)
                    .then(result => {
                        if (result.status >= 200 && result.status < 300) {
                            return result.json();
                        } else {
                            return result.json().then(Promise.reject.bind(Promise));
                        }
                    })
                    .then(
                        json => {
                            dispatch(newNotification({ title: "¡Éxito!", content: json.message ? json.message : 'Clausulas guardados correctamente', type: "success" }));
                            return dispatch(financialGoalConagoData(json, values, data, modality, 'close'));
                        },
                        error => {
                            dispatch(newNotification({ title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error), type: "danger" }));
                            return dispatch(reportsFinancialEditFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
                        }
                    );
            })
    }
};

const reportsFinancialData = (json) => {
    return {
        type: REPORTS_FINANCIAL,
        isFetching: false,
        payload: {
            ...json.data,
            editable: json.editable
        },
        revision: json.revision ? {
            ...json.revision,
            body: JSON.parse(json.revision.body)
        } : {},
        version: json.version,
        permissions: json.permissions,
        timestamp: Date.now()
    }
};

const reportsFinancialRequest = () => {
    return {
        type: REPORTS_FINANCIAL_REQUEST,
        isFetching: true,
        timestamp: Date.now()
    }
};

const financialGoalData = (json, values, data, mod, action) => {
    let response = data;
    let edit = {};
    response.proigualdad_axis[values.indexAxis].project_goals[values.indexGoal] = json.data;
    if (mod !== 'modalidad-iii') {
        edit = response.proigualdad_axis[values.indexAxis].project_goals[values.indexGoal].project_version_phase_goal
    } else {
        let findAgency = _.find(response.proigualdad_axis[values.indexAxis].project_goals[values.indexGoal].project_version_phase_goal, { agency_id: _.toNumber(values.agency_id) });
        edit = findAgency ? findAgency : {};
    }
    return {
        type: REPORTS_FINANCIAL_GOAL,
        isFetching: false,
        payload: response,
        edit: {
            ...edit,
            indexAxis: values.indexAxis,
            indexGoal: values.indexGoal,
            action: action
        },
        permissions: json.permissions,
        timestamp: Date.now()
    }
};

const financialGoalInvoiceData = (json, values, data, mod, action) => {
    let response = data;
    let edit = {};
    response.proigualdad_axis[values.indexAxis].project_goals[values.indexGoal] = json.data;
    if (mod !== 'modalidad-iii') {
        edit = response.proigualdad_axis[values.indexAxis].project_goals[values.indexGoal].project_version_phase_goal
    } else {
        let findAgency = _.find(response.proigualdad_axis[values.indexAxis].project_goals[values.indexGoal].project_version_phase_goal, { agency_id: values.agency_id });
        edit = findAgency ? {...findAgency, agencies: response.proigualdad_axis[values.indexAxis].project_goals[values.indexGoal].agencies } : {};
    }
    return {
        type: REPORTS_FINANCIAL_GOAL,
        isFetching: false,
        payload: response,
        edit: {
            ...edit,
            indexAxis: values.indexAxis,
            indexGoal: values.indexGoal,
            pdf: undefined,
            xml: undefined,
            sat: undefined,
            action: action
        },
        permissions: json.permissions,
        timestamp: Date.now()
    }
};

const financialActivityData = (json, values, data, mod, action) => {
    let response = data;
    let edit = {};
    response.proigualdad_axis[values.indexAxis].project_goals[values.indexGoal].project_goal_activities[values.indexActivity] = json.data;
    if (mod !== 'modalidad-iii') {
        edit = response.proigualdad_axis[values.indexAxis].project_goals[values.indexGoal].project_goal_activities[values.indexActivity].project_version_phase_goal_activity
    } else {
        let findAgency = _.find(response.proigualdad_axis[values.indexAxis].project_goals[values.indexGoal].project_goal_activities[values.indexActivity].project_version_phase_goal_activity, { agency_id: _.toNumber(values.agency_id) });
        edit = findAgency ? findAgency : {};
    }
    return {
        type: REPORTS_FINANCIAL_ACTIVITY,
        isFetching: false,
        payload: response,
        edit: {
            ...edit,
            project_goal_id: values.project_goal_id,
            indexAxis: values.indexAxis,
            indexGoal: values.indexGoal,
            indexActivity: values.indexActivity,
            action: action
        },
        permissions: json.permissions,
        timestamp: Date.now()
    }
};

const financialGoalActorsData = (json, values, data, mod, action) => {
    let response = data;
    response.proigualdad_axis[values.indexAxis].project_goals[values.indexGoal] = json.data;
    let edit = response.proigualdad_axis[values.indexAxis].project_goals[values.indexGoal].actors
    return {
        type: REPORTS_FINANCIAL_GOAL,
        isFetching: false,
        payload: response,
        edit: {
            ...edit,
            indexAxis: values.indexAxis,
            indexGoal: values.indexGoal,
            action: action
        },
        permissions: json.permissions,
        timestamp: Date.now()
    }
};

const financialGoalConagoData = (json, values, data, mod, action) => {
    let response = data;
    response.proigualdad_axis[values.indexAxis].project_goals[values.indexGoal] = json.data;
    let edit = response.proigualdad_axis[values.indexAxis].project_goals[values.indexGoal].conago_clauses
    return {
        type: REPORTS_FINANCIAL_GOAL,
        isFetching: false,
        payload: response,
        edit: {
            ...edit,
            indexAxis: values.indexAxis,
            indexGoal: values.indexGoal,
            action: action
        },
        permissions: json.permissions,
        timestamp: Date.now()
    }
};

const reportsFinancialEditRequest = () => {
    return {
        type: REPORTS_FINANCIAL_EDIT_REQUEST,
        isFetching: true,
        timestamp: Date.now()
    }
};

/*
const reportsFinancialEditInvoiceFail = () => {
	return{
		type: REPORTS_FINANCIAL_EDIT_INVOICE_FAIL,
		show: true,
		timestamp: Date.now()
	}
};*/

const reportsFinancialEditFail = (error) => {
    return {
        type: REPORTS_FINANCIAL_EDIT_FAIL,
        isFetching: false,
        payload: error,
        timestamp: Date.now()
    }
};

const reportsFinancialClear = () => {
    return {
        type: REPORTS_FINANCIAL_CLEAR,
        payload: {},
        timestamp: Date.now()
    }
};

const reportsFinancialFail = (error) => {
    return {
        type: REPORTS_FINANCIAL_FAIL,
        isFetching: false,
        payload: error,
        timestamp: Date.now()
    }
};

export const reportsExpenses = (modality, state, mun = undefined) => (dispatch) => {
    return dispatch(sessionService.loadUser)
        .then(sess => {
            dispatch(reportsExpensesRequest());
            dispatch(reportsExpensesClear());

            const options = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sess.profile.access_token}`
                },
                method: 'get'
            };

            return fetch(`${API2_URL}/projects/reports/expenses/${modality}/${state}${mun !== undefined ? '/' + mun : ''}`, options)
                .then(result => {
                    if (result.status >= 200 && result.status < 300) {
                        return result.json();
                    } else {
                        return result.json().then(Promise.reject.bind(Promise));
                    }
                })
                .then(
                    json => dispatch(reportsExpensesData(json)),
                    error => {
                        dispatch(newNotification({ title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error), type: "danger" }));
                        return dispatch(reportsExpensesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
                    }
                );
        })
};

export const expenseInvoicesSave = (modality, state, mun = undefined, values) => (dispatch) => {
    return dispatch(sessionService.loadUser)
        .then(sess => {
            dispatch(reportsExpensesEditRequest());

            let body = new FormData();
            let countCdm = 0;

            _.mapKeys({ pdf: values.pdf, xml: values.xml, sat: values.sat }, (o, j) => {
                if (o !== undefined) {
                    if (!_.isObject(o) && !_.startsWith(o, 'http://')) {
                        body.append(j, o);
                    } else if (_.isObject(o) && !_.isEmpty(o) && o[0] !== undefined) {
                        body.append(j, o[0]);
                    }
                }
            });

            if (modality === 'modalidad-iii') {
                _.mapKeys(values.agencies, (o) => {
                    let agencyId = undefined;
                    _.mapKeys(o, (v, k) => {
                        if (k === 'id') {
                            agencyId = v;
                        }

                        if (k === 'amount') {
                            if (v !== undefined && !_.isEmpty(v)) {
                                body.append(`agencies[${countCdm}][agency_id]`, agencyId);
                                body.append(`agencies[${countCdm}][${k}]`, v);
                                countCdm += 1;
                            }
                        }
                    })
                });
            }

            const options = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${sess.profile.access_token}`
                },
                method: 'post',
                body: body
            };

            return fetch(`${API2_URL}/projects/reports/expenses/${values.project_expense_id}/invoices/${modality}/${state}${mun !== undefined ? '/' + mun : ''}`, options)
                .then(result => {
                    if (result.status >= 200 && result.status < 300) {
                        return result.json();
                    } else {
                        return result.json().then(Promise.reject.bind(Promise));
                    }
                })
                .then(
                    json => {
                        dispatch(newNotification({ title: "¡Éxito!", content: json.message ? json.message : 'Factura guardada correctamente', type: "success" }));
                        return dispatch(reportsExpensesEditData(json, values, modality, 'close'));
                    },
                    error => {
                        dispatch(newNotification({ title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error), type: "danger" }));
                        return dispatch(reportsExpensesEditFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
                    }
                );
        })
};

export const expensesInvoiceDelete = (values, id, modality, state, mun = undefined) => (dispatch) => {
    return dispatch(sessionService.loadUser)
        .then(sess => {
            dispatch(reportsExpensesEditRequest());

            const options = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sess.profile.access_token}`
                },
                method: 'delete'
            };

            return fetch(`${API2_URL}/projects/reports/expenses/${values.project_expense_id}/invoices/${id}/${modality}/${state}${mun !== undefined ? '/' + mun : ''}`, options)
                .then(result => {
                    if (result.status >= 200 && result.status < 300) {
                        return result.json();
                    } else {
                        return result.json().then(Promise.reject.bind(Promise));
                    }
                })
                .then(
                    json => {
                        dispatch(newNotification({ title: "¡Éxito!", content: json.message ? json.message : 'La factura se elimino correctamente', type: "success" }));
                        return dispatch(reportsExpensesEditData(json, values, modality, 'delete'));
                    },
                    error => {
                        dispatch(newNotification({ title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error), type: "danger" }));
                        return dispatch(reportsExpensesEditFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
                    }
                );
        })
};

export const expenseReceiptsSave = (modality, state, mun = undefined, values) => (dispatch) => {
    return dispatch(sessionService.loadUser)
        .then(sess => {
            dispatch(reportsExpensesEditRequest());

            let body = new FormData();
            let countCdm = 0;

            _.mapKeys({ file: values.file, total: values.total, date: values.date, concepts: values.concepts }, (o, j) => {
                if (o !== undefined) {
                    if (!_.isObject(o) && !_.startsWith(o, 'http://')) {
                        body.append(j, o);
                    } else if (_.isObject(o) && !_.isEmpty(o) && o[0] !== undefined) {
                        body.append(j, o[0]);
                    }
                }
            });

            if (modality === 'modalidad-iii') {
                _.mapKeys(values.agencies, (o) => {
                    let agencyId = undefined;
                    _.mapKeys(o, (v, k) => {
                        if (k === 'id') {
                            agencyId = v;
                        }

                        if (k === 'amount') {
                            if (v !== undefined && !_.isEmpty(v)) {
                                body.append(`agencies[${countCdm}][agency_id]`, agencyId);
                                body.append(`agencies[${countCdm}][${k}]`, v);
                                countCdm += 1;
                            }
                        }
                    })
                });
            }

            const options = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${sess.profile.access_token}`
                },
                method: 'post',
                body: body
            };

            return fetch(`${API2_URL}/projects/reports/expenses/${values.project_expense_id}/receipts/${modality}/${state}${mun !== undefined ? '/' + mun : ''}`, options)
                .then(result => {
                    if (result.status >= 200 && result.status < 300) {
                        return result.json();
                    } else {
                        return result.json().then(Promise.reject.bind(Promise));
                    }
                })
                .then(
                    json => {
                        dispatch(newNotification({ title: "¡Éxito!", content: json.message ? json.message : 'Comprobante guardada correctamente', type: "success" }));
                        return dispatch(reportsExpensesEditData(json, values, modality, 'close'));
                    },
                    error => {
                        dispatch(newNotification({ title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error), type: "danger" }));
                        return dispatch(reportsExpensesEditFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
                    }
                );
        })
};

export const expensesReceiptDelete = (values, id, modality, state, mun = undefined) => (dispatch) => {
    return dispatch(sessionService.loadUser)
        .then(sess => {
            dispatch(reportsExpensesEditRequest());

            const options = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sess.profile.access_token}`
                },
                method: 'delete'
            };

            return fetch(`${API2_URL}/projects/reports/expenses/${values.project_expense_id}/receipts/${id}/${modality}/${state}${mun !== undefined ? '/' + mun : ''}`, options)
                .then(result => {
                    if (result.status >= 200 && result.status < 300) {
                        return result.json();
                    } else {
                        return result.json().then(Promise.reject.bind(Promise));
                    }
                })
                .then(
                    json => {
                        dispatch(newNotification({ title: "¡Éxito!", content: json.message ? json.message : 'La factura se elimino correctamente', type: "success" }));
                        return dispatch(reportsExpensesEditData(json, values, modality, 'delete'));
                    },
                    error => {
                        dispatch(newNotification({ title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error), type: "danger" }));
                        return dispatch(reportsExpensesEditFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
                    }
                );
        })
};

const reportsExpensesData = (json) => {
    return {
        type: REPORTS_EXPENSES,
        isFetching: false,
        payload: {
            ...json.data,
            editable: json.editable
        },
        revision: json.revision ? {
            ...json.revision,
            body: JSON.parse(json.revision.body)
        } : {},
        version: json.version,
        permissions: json.permissions,
        timestamp: Date.now()
    }
};

const reportsExpensesRequest = () => {
    return {
        type: REPORTS_EXPENSES_REQUEST,
        isFetching: true,
        timestamp: Date.now()
    }
};

const reportsExpensesClear = () => {
    return {
        type: REPORTS_EXPENSES_CLEAR,
        payload: {},
        timestamp: Date.now()
    }
};

const reportsExpensesFail = (error) => {
    return {
        type: REPORTS_EXPENSES_FAIL,
        isFetching: false,
        payload: error,
        timestamp: Date.now()
    }
};

const reportsExpensesEditData = (json, values, mod, action) => {
    let edit = {}
    if (mod !== 'modalidad-iii') {
        edit = json.data.project_expenses[values.indexExpense].project_version_phase_expense
    } else {
        edit = {...json.data.project_expenses[values.indexExpense].project_version_phase_expense, agencies: json.data.agencies }
    }
    return {
        type: REPORTS_EXPENSES_EDIT,
        isFetching: false,
        payload: {
            ...json.data,
            editable: json.editable
        },
        edit: {
            ...edit,
            indexExpense: values.indexExpense,
            pdf: undefined,
            xml: undefined,
            sat: undefined,
            file: undefined,
            total: undefined,
            date: undefined,
            concepts: undefined,
            action: action
        },
        permissions: json.permissions,
        timestamp: Date.now()
    }
};

const reportsExpensesEditRequest = () => {
    return {
        type: REPORTS_EXPENSES_EDIT_REQUEST,
        isFetching: true,
        timestamp: Date.now()
    }
};

const reportsExpensesEditFail = (error) => {
    return {
        type: REPORTS_EXPENSES_EDIT_FAIL,
        isFetching: false,
        payload: error,
        timestamp: Date.now()
    }
};

export const reportsEmployees = (modality, state, mun = undefined) => (dispatch) => {
    return dispatch(sessionService.loadUser)
        .then(sess => {
            dispatch(reportsEmployeesRequest());
            dispatch(reportsEmployeesClear());

            const options = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sess.profile.access_token}`
                },
                method: 'get'
            };

            return fetch(`${API2_URL}/projects/reports/employees/${modality}/${state}${mun !== undefined ? '/' + mun : ''}`, options)
                .then(result => {
                    if (result.status >= 200 && result.status < 300) {
                        return result.json();
                    } else {
                        return result.json().then(Promise.reject.bind(Promise));
                    }
                })
                .then(
                    json => dispatch(reportsEmployeesData(json)),
                    error => {
                        dispatch(newNotification({ title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error), type: "danger" }));
                        return dispatch(reportsEmployeesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
                    }
                );
        })
};

export const reportsEmployeeAdd = (values, modality, state, mun = undefined) => (dispatch) => {
    return dispatch(sessionService.loadUser)
        .then(sess => {
            dispatch(reportsEmployeesEditRequest());

            const options = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sess.profile.access_token}`
                },
                method: 'post',
                body: JSON.stringify(values)
            };

            return fetch(`${API2_URL}/projects/reports/employees/goal/${values.project_goal_id}/employee/${modality}/${state}${mun !== undefined ? '/' + mun : ''}`, options)
                .then(result => {
                    if (result.status >= 200 && result.status < 300) {
                        return result.json();
                    } else {
                        return result.json().then(Promise.reject.bind(Promise));
                    }
                })
                .then(
                    json => {
                        dispatch(newNotification({ title: "¡Éxito!", content: json.message ? json.message : 'El registro se guardó correctamente', type: "success" }));
                        return dispatch(reportsEmployeesEditData(json, values, modality, 'close'));
                    },
                    error => {
                        dispatch(newNotification({ title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error), type: "danger" }));
                        return dispatch(reportsEmployeesEditFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
                    }
                );
        })
};

export const reportsEmployeeInvoicesSave = (values, modality, state, mun = undefined) => (dispatch) => {
    return dispatch(sessionService.loadUser)
        .then(sess => {
            dispatch(reportsEmployeesEditRequest());

            let body = new FormData();

            _.mapKeys({ pdf: values.pdf, xml: values.xml, sat: values.sat }, (o, j) => {
                if (o !== undefined) {
                    if (!_.isObject(o) && !_.startsWith(o, 'http://')) {
                        body.append(j, o);
                    } else if (_.isObject(o) && !_.isEmpty(o) && o[0] !== undefined) {
                        body.append(j, o[0]);
                    }
                }
            });

            if (modality === 'modalidad-iii') {
                if (values.agency_id !== undefined) {
                    body.append(`agency_id`, values.agency_id);
                }
            }

            const options = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${sess.profile.access_token}`
                },
                method: 'post',
                body: body
            };

            return fetch(`${API2_URL}/projects/reports/employees/employee/${values.id}/invoices/${modality}/${state}${mun !== undefined ? '/' + mun : ''}`, options)
                .then(result => {
                    if (result.status >= 200 && result.status < 300) {
                        return result.json();
                    } else {
                        //dispatch(reportsFinancialEditInvoiceFail());
                        return result.json().then(Promise.reject.bind(Promise));
                    }
                })
                .then(
                    json => {
                        dispatch(newNotification({ title: "¡Éxito!", content: json.message, type: "success" }));
                        return dispatch(reportsEmployeesEditData(json, values, modality, 'close'));
                    },
                    error => {
                        dispatch(newNotification({ title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error), type: "danger" }));
                        return dispatch(reportsEmployeesEditFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
                    }
                );
        })
};

export const reportsEmployeeInvoiceDelete = (values, id, modality, state, mun = undefined) => (dispatch) => {
    return dispatch(sessionService.loadUser)
        .then(sess => {
            dispatch(reportsEmployeesEditRequest());

            const options = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sess.profile.access_token}`
                },
                method: 'delete'
            };

            return fetch(`${API2_URL}/projects/reports/employees/employee/${values.id}/invoices/${id}/${modality}/${state}${mun !== undefined ? '/' + mun : ''}`, options)
                .then(result => {
                    if (result.status >= 200 && result.status < 300) {
                        return result.json();
                    } else {
                        return result.json().then(Promise.reject.bind(Promise));
                    }
                })
                .then(
                    json => {
                        dispatch(newNotification({ title: "¡Éxito!", content: json.message ? json.message : 'La factura se elimino correctamente', type: "success" }));
                        return dispatch(reportsEmployeesEditData(json, values, modality, 'delete'));
                    },
                    error => {
                        dispatch(newNotification({ title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error), type: "danger" }));
                        return dispatch(reportsEmployeesEditFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
                    }
                );
        })
};

const reportsEmployeesData = (json) => {
    let revision = json.revision;
    let employees = [];
    let agencies = [];

    if (json.data && json.data.project_goals) {
        _.map(json.data.project_goals, (item) => {
            if (item.project_goal_agencies) {
                _.map(item.project_goal_agencies, (goal) => {
                    if (goal.agency) {
                        agencies.push({...goal.agency })
                    }

                    if (goal.employees) {
                        _.map(goal.employees, (emp) => {
                            let data = {};

                            _.mapKeys(emp, (i, k) => {
                                data = {
                                    ...data,
                                    [k]: i ? i : undefined
                                }
                            })

                            employees.push({
                                ...data,
                                agency_id: goal.agency_id,
                                project_goal_id: goal.project_goal_id,
                                agency: {...goal.agency }
                            });
                        })
                    }
                })
            }
        })
    }

    if (_.isEmpty(json.revision)) {
        revision = _.find(json.revisions, { project_version_phase: { version_phase: { phase: { slug: 'project-report-goals' } } } });
    }

    return {
        type: REPORTS_EMPLOYEES,
        isFetching: false,
        payload: {
            ...json.data,
            employees,
            agencies,
            editable: json.editable
        },
        revision: revision ? {
            ...revision,
            body: JSON.parse(revision.body)
        } : {},
        version: json.version,
        permissions: json.permissions,
        timestamp: Date.now()
    }
};

const reportsEmployeesRequest = () => {
    return {
        type: REPORTS_EMPLOYEES_REQUEST,
        isFetching: true,
        timestamp: Date.now()
    }
};

const reportsEmployeesClear = () => {
    return {
        type: REPORTS_EMPLOYEES_CLEAR,
        payload: {},
        timestamp: Date.now()
    }
};

const reportsEmployeesFail = (error) => {
    return {
        type: REPORTS_EMPLOYEES_FAIL,
        isFetching: false,
        payload: error,
        timestamp: Date.now()
    }
};

const reportsEmployeesEditData = (json, values, mod, action) => {
    let index = undefined;
    let employees = [];
    let agencies = [];

    if (json.data && json.data.project_goals) {
        _.map(json.data.project_goals, (item) => {
            if (item.project_goal_agencies) {
                _.map(item.project_goal_agencies, (goal) => {
                    if (goal.agency) {
                        agencies.push({...goal.agency })
                    }

                    if (goal.employees) {
                        _.map(goal.employees, (emp) => {
                            let data = {};

                            _.mapKeys(emp, (i, k) => {
                                data = {
                                    ...data,
                                    [k]: i ? i : undefined
                                }
                            })

                            employees.push({
                                ...data,
                                agency_id: goal.agency_id,
                                project_goal_id: goal.project_goal_id,
                                agency: {...goal.agency }
                            });
                        })
                    }
                })
            }
        })
    }


    if (values.indexEmployees) {
        index = values.indexEmployees;
    } else {
        index = employees.length - 1;
    }

    let edit = {}

    edit = employees[index]

    return {
        type: REPORTS_EMPLOYEES_EDIT,
        isFetching: false,
        payload: {
            ...json.data,
            employees,
            agencies,
            editable: json.editable
        },
        edit: {
            ...edit,
            indexEmployees: values.indexEmployees,
            pdf: undefined,
            xml: undefined,
            sat: undefined,
            action: action
        },
        permissions: json.permissions,
        timestamp: Date.now()
    }
};

const reportsEmployeesEditRequest = () => {
    return {
        type: REPORTS_EMPLOYEES_EDIT_REQUEST,
        isFetching: true,
        timestamp: Date.now()
    }
};

const reportsEmployeesEditFail = (error) => {
    return {
        type: REPORTS_EMPLOYEES_EDIT_FAIL,
        isFetching: false,
        payload: error,
        timestamp: Date.now()
    }
};

export const reportsSummary = (modality, state, mun = undefined) => (dispatch) => {
    return dispatch(sessionService.loadUser)
        .then(sess => {
            dispatch(reportsSummaryRequest());
            dispatch(reportsSummaryClear());

            const options = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sess.profile.access_token}`
                },
                method: 'get'
            };

            return fetch(`${API2_URL}/projects/reports/summary/${modality}/${state}${mun !== undefined ? '/' + mun : ''}`, options)
                .then(result => {
                    if (result.status >= 200 && result.status < 300) {
                        return result.json();
                    } else {
                        return result.json().then(Promise.reject.bind(Promise));
                    }
                })
                .then(
                    json => dispatch(reportsSummaryData(json)),
                    error => {
                        dispatch(newNotification({ title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error), type: "danger" }));
                        return dispatch(reportsSummaryFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
                    }
                );
        })
};

export const reportsSummaryExport = (modality, state, mun = undefined) => (dispatch) => {
    return dispatch(sessionService.loadUser)
        .then(sess => {
            dispatch(reportsSummaryRequest());

            const options = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sess.profile.access_token}`
                },
                method: 'get'
            };

            return fetch(`${API2_URL}/projects/reports/summary/${modality}/${state}${mun !== undefined ? '/' + mun : ''}?export=1`, options)
                .then(result => {
                    if (result.status >= 200 && result.status < 300) {
                        return result.blob();
                    } else {
                        return result.json().then(Promise.reject.bind(Promise));
                    }
                })
                .then(
                    blob => {
                        let today = new Date();
                        let date = today.getFullYear() + ((today.getMonth() + 1) < 10 ? `0${today.getMonth() + 1}` : today.getMonth() + 1) + (today.getDate() < 10 ? `0${today.getDate()}` : today.getDate()) + today.getHours() + today.getMinutes() + today.getSeconds();
                        FileSaver.saveAs(blob, `resumen_informe_de_vance_físico_y_financiero_${state}${mun !== undefined ? '_' + mun : ''}_${date}.pdf`);
                        dispatch(reportsSummaryComplete());

                    },
                    error => {
                        dispatch(newNotification({ title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error), type: "danger" }));
                        return dispatch(reportsSummaryFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
                    }
                );
        })
};

export const reportsSummarySave = (values, modality, state, mun = undefined, percentages) => (dispatch) => {
    return dispatch(sessionService.loadUser)
        .then(sess => {
            dispatch(reportsSummaryRequest());

            let body = new FormData();

            _.mapKeys(values, (o, j) => {
                if (o !== undefined) {
                    if (!_.isObject(o) && !_.startsWith(o, 'http://')) {
                        body.append(j, o);
                    } else if (_.isObject(o) && !_.isEmpty(o) && o[0] !== undefined) {
                        body.append(j, o[0]);
                    }
                }
            });

            if (percentages !== undefined) {
                percentages.forEach((percentage, index) => {
                    const pp = `percentage${index}`
                    body.append(pp, percentage)
                })

            }

            const objectPercentages = {};
            body.forEach(function(value, key) {
                objectPercentages[key] = value;
            });

            const options = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${sess.profile.access_token}`
                },
                method: 'post',
                body: body
            };
            return fetch(`${API2_URL}/projects/reports/summary/${modality}/${state}${mun !== undefined ? '/' + mun : ''}`, options)
                .then(result => {
                    if (result.status >= 200 && result.status < 300) {
                        return result.json();
                    } else {
                        return result.json().then(Promise.reject.bind(Promise));
                    }
                })
                .then(
                    json => {
                        dispatch(newNotification({ title: "¡Éxito!", content: json.message ? json.message : 'Resumen guardado exitosamente', type: "success" }));

                        if (!!percentages) {
                            return dispatch(reportsSummary(modality, state))
                        } else {
                            return dispatch(reportsSummaryData(json))
                        }


                    },
                    error => {
                        dispatch(newNotification({ title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error), type: "danger" }));
                        return dispatch(reportsSummaryFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
                    }
                );
        })
};

const reportsSummaryData = (json) => {
    let documents = {};
    //console.log(json);
    /*if (json.data.project_version_phase_group && json.data.project_version_phase_group.documents) {
    	_.map(json.data.project_version_phase_group.documents, (item) => {
    		documents = {
    			...documents,
    			[item.documentable_subtype]: item.file
    		}
    	})
    }*/

    if (json.data.agency && json.data.agency.documents) {
        _.map(json.data.agency.documents, (item) => {
            documents = {
                ...documents,
                [item.documentable_subtype]: item.file
            }
        })
    }

    return {
        type: REPORTS_SUMMARY,
        isFetching: false,
        payload: {
            ...json.data,
            editable: json.editable,
            finished: json.finished,
            documents_items: json.documents_items
        },
        edit: {
            ...documents,
            finished: json.finished
        },
        revision: json.revision ? {
            ...json.revision,
            body: JSON.parse(json.revision.body)
        } : {},
        phase_group: json.phase_group,
        permissions: json.permissions,
        version: json.version,
        timestamp: Date.now()
    }
};

const reportsSummaryRequest = () => {
    return {
        type: REPORTS_SUMMARY_REQUEST,
        isFetching: true,
        timestamp: Date.now()
    }
};

const reportsSummaryComplete = () => {
    return {
        type: REPORTS_SUMMARY_COMPLETE,
        isFetching: false,
        timestamp: Date.now()
    }
};

const reportsSummaryClear = () => {
    return {
        type: REPORTS_SUMMARY_CLEAR,
        payload: {},
        timestamp: Date.now()
    }
};

const reportsSummaryFail = (error) => {
    return {
        type: REPORTS_SUMMARY_FAIL,
        isFetching: false,
        payload: error,
        timestamp: Date.now()
    }
};

export const reportsSurvey = (modality, state, mun = undefined) => (dispatch) => {
    return dispatch(sessionService.loadUser)
        .then(sess => {
            dispatch(reportsSurveyRequest());
            dispatch(reportsSurveyClear());

            const options = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sess.profile.access_token}`
                },
                method: 'get'
            };

            return fetch(`${API2_URL}/projects/reports/survey/${modality}/${state}${mun !== undefined ? '/' + mun : ''}`, options)
                .then(result => {
                    if (result.status >= 200 && result.status < 300) {
                        return result.json();
                    } else {
                        return result.json().then(Promise.reject.bind(Promise));
                    }
                })
                .then(
                    json => dispatch(reportsSurveyData(json)),
                    error => {
                        dispatch(newNotification({ title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error), type: "danger" }));
                        return dispatch(reportsSurveyFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
                    }
                );
        })
};

export const reportsSurveySave = (values, modality, state, mun = undefined) => (dispatch) => {
    let answers = []

    _.map(values.children_questions, (item) => {
        if (item.type === "group") {
            _.map(item.children_questions, (q) => {
                if (q.answer !== null && q.answer !== undefined) {
                    return answers.push({ question_id: q.id, answer: q.answer })
                }
            })
        } else {
            if (item.answer !== null && item.answer !== undefined) {
                return answers.push({ question_id: item.id, answer: item.answer })
            }
        }
    })
    if (!_.isEmpty(answers)) {
        return dispatch(sessionService.loadUser)
            .then(sess => {
                dispatch(reportsSurveyRequest());

                const options = {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${sess.profile.access_token}`
                    },
                    method: 'post',
                    body: JSON.stringify({ answers })
                };

                return fetch(`${API2_URL}/projects/reports/survey/${modality}/${state}${mun !== undefined ? '/' + mun : ''}`, options)
                    .then(result => {
                        if (result.status >= 200 && result.status < 300) {
                            return result.json();
                        } else {
                            return result.json().then(Promise.reject.bind(Promise));
                        }
                    })
                    .then(
                        json => {
                            dispatch(newNotification({ title: "¡Éxito!", content: json.message, type: "success" }));
                            return dispatch(reportsSurveyData(json));
                        },
                        error => {
                            dispatch(newNotification({ title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error), type: "danger" }));
                            return dispatch(reportsSurveyFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
                        }
                    );
            })
    } else {
        dispatch(newNotification({ title: '¡Oh no!', content: 'Favor de contestar las preguntas antes de guardar', type: 'danger' }))
        return dispatch(reportsSurveyFail('Favor de contestar las preguntas antes de guardar'));
    }
};

const reportsSurveyData = (json) => {
    return {
        type: REPORTS_SURVEYS,
        isFetching: false,
        payload: {
            ...json.data,
            editable: json.editable
        },
        version: json.version,
        permissions: json.permissions,
        timestamp: Date.now()
    }
};

const reportsSurveyRequest = () => {
    return {
        type: REPORTS_SURVEYS_REQUEST,
        isFetching: true,
        timestamp: Date.now()
    }
};

const reportsSurveyClear = () => {
    return {
        type: REPORTS_SURVEYS_CLEAR,
        payload: {},
        timestamp: Date.now()
    }
};

const reportsSurveyFail = (error) => {
    return {
        type: REPORTS_SURVEYS_FAIL,
        isFetching: false,
        payload: error,
        timestamp: Date.now()
    }
};


// WEBPACK FOOTER //
// ./src/actions/reports.js